import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProjectType } from "../../../types/ScientificModule";

const initialState: ProjectType = {
    id: "",
    description: "",
    startdate: "",
    enddate: "",
    entityName: "",
   // idEntity: "",
    idProjectType: "",
    isFinanced: false,
    moneyInvested: 0,
    objectives: "",
    principalDocBase64: "",
    status: false,
    principalDocBase64File: undefined
};

const projectsSlice = createSlice({
    name: "projects",
    initialState,
    reducers: {
        setProjectsData: (state, action: PayloadAction<ProjectType>) => ({
            ...state,
            ...action.payload,
        }),
        resetProjectsData: () => ({ ...initialState }),
    },
});

export const { setProjectsData, resetProjectsData } = projectsSlice.actions;

export default projectsSlice.reducer;
